// Single source of truth for the producer contact details shown in the
// "Contact Henry" modal on the client review page. The brand promise is that
// clients work directly with Henry — a person, not a support desk — so this is
// deliberately one named human.
//
// Email stays henry@henrysheahanproductions.com: the live inbox until the
// Sheahan Studios address launches (INTEGRATION-EXECUTION-PLAN.md rule #8). Keep
// this in step with ContactLine.tsx's CONTACT_EMAIL if that address ever moves.
export const PRODUCER = {
  name: 'Henry Sheahan',
  role: 'your producer',
  email: 'henry@henrysheahanproductions.com',
  replyTime: 'Replies within a business day',
  /** Avatar initial — a circular teal mark, so there's no photo asset to ship. */
  initial: 'H',
} as const;
